import { DashboardVariantEnum } from '@models/enums';
import { useAppSelector } from '@store';

export const useActiveProduct = () => {
    // optional chaining: widget npm bundle uses a lighter store without `dashboard` slice
    const variantId = useAppSelector((state) => state.dashboard?.session?.dashboardVariantId);

    return {
        variantId,
        isKyc: variantId === DashboardVariantEnum.KYC,
        isKyt: variantId === DashboardVariantEnum.KYT,
        isDeepfake: variantId === DashboardVariantEnum.DEEPFAKE,
    };
};
